import numeral from 'numeral'
import PropTypes from 'prop-types'
import React from 'react'
// load a language
numeral.language('it', {
  delimiters: {
    thousands: '.',
    decimal: ',',
  },
  abbreviations: {
    thousand: 'k',
    million: 'm',
    billion: 'b',
    trillion: 't',
  },

  currency: {
    symbol: '€',
  },
})

const FenancementDetailsFindomestic = ({ nota_legale }) => {
  numeral.language('it')
  numeral.defaultFormat('$ 0,0.00')

  return (
    <p>
      <span>{nota_legale}</span>
      <span
        style={{ marginTop: '10px', marginBottom: '10px', display: 'block' }}
      >
        Scarica la
        <span>
          &nbsp;
          <a
            href={
              'https://secure.findomestic.it/documenti/trasparenza/TA2352.pdf'
            }
            rel="noreferrer"
            target={'_blank'}
          >
            Tabella Antiusura
          </a>
          , la{' '}
        </span>
        <span>
          <a
            href={
              'https://secure.findomestic.it/documenti/trasparenza/TA2694.pdf'
            }
            rel="noreferrer"
            target={'_blank'}
          >
            Guida all’Arbitro Bancario Finanziario
          </a>{' '}
        </span>
        <span>e la Guida </span>
        <span>
          <a
            href={
              'https://secure.findomestic.it/documenti/trasparenza/TB8009.pdf'
            }
            rel="noreferrer"
            target={'_blank'}
          >
            "Il credito ai consumatori in parole semplici"
          </a>
        </span>
      </span>
    </p>
  )
}

FenancementDetailsFindomestic.defaultProps = {
  nota_legale: '',
}

FenancementDetailsFindomestic.propTypes = {
  nota_legale: PropTypes.string,
}

export default FenancementDetailsFindomestic
